export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';

export const LINK_SERVICE_EXISTS_ERROR_CODE = 'ServiceAlreadyExists';

export const SUPPORTED_MAJOR_VERSION = 3.4;
